import theme from '@cubeyou-team/hx-theme';

import {
  DATA_SOURCE_IDS,
  FUSION_TYPES,
  DATA_SOURCE_COLOR_RGB_MAP,
  DATA_SOURCE_COLORS,
} from '@discover-frontend/constants';

const hasItemSource = (source: string) =>
  (Object.values(FUSION_TYPES) as string[]).includes(source);

const dataSourceColorMap = Object.fromEntries(
  Object.entries(DATA_SOURCE_IDS).map(([colorKey, sourceId]) => [
    sourceId,
    DATA_SOURCE_COLORS[colorKey],
  ])
);

const DiscoverSources = [
  {
    id: DATA_SOURCE_IDS.TWITTER,
    condition: !hasItemSource(DATA_SOURCE_IDS.TWITTER),
  },
  { id: DATA_SOURCE_IDS.INSTAGRAM_FOLLOWS, condition: true },
  { id: DATA_SOURCE_IDS.DISCOVER, condition: true },
];

const isDiscover = (source: string) =>
  DiscoverSources.some(item => item.condition && item.id === source);

export const getBackgroundColor = (source: string, isTailwind = false) => {
  if (isTailwind) {
    return `bg-custom-${dataSourceColorMap[source]}`;
  }

  const color =
    DATA_SOURCE_COLOR_RGB_MAP[source] ||
    DATA_SOURCE_COLOR_RGB_MAP[DATA_SOURCE_IDS.TWITTER];

  const backgroundColor = isDiscover(source) ? theme.colors.primary : color;

  return backgroundColor;
};
